


interface WsGlobalArea {
  id:   string;
  name: string;
}



interface WsGlobalRegion {
  id:     string;
  name:   string;
  areaId: string;
}



const globalAreas: WsGlobalArea[] = [
  { id: 'EME', name: 'EME' },
  { id: 'GM',  name: 'GM'  },
  { id: 'NA',  name: 'NA'  },
];

const getGlobalAreas = () => {
  return globalAreas;
};

const globalRegions: WsGlobalRegion[] = [
  { id: 'ASG',           name: 'ASG',           areaId: 'EME' },
  { id: 'GALLIA',        name: 'Gallia',        areaId: 'EME' },
  { id: 'IBERIA',        name: 'Iberia',        areaId: 'EME' },
  { id: 'ICEG',          name: 'ICEG',          areaId: 'EME' },
  { id: 'NORDICS',       name: 'Nordics',       areaId: 'EME' },
  { id: 'UAE',           name: 'UAE',           areaId: 'EME' },
  { id: 'UKI',           name: 'UKI',           areaId: 'EME' },
  { id: 'AUSTRALIA',     name: 'Australia',     areaId: 'GM'  },
  { id: 'BRAZIL',        name: 'Brazil',        areaId: 'GM'  },
  { id: 'GREATER_CHINA', name: 'Greater China', areaId: 'GM'  },
  { id: 'JAPAN',         name: 'Japan',         areaId: 'GM'  },
  { id: 'SEA',           name: 'SEA',           areaId: 'GM'  },
  { id: 'CANADA',        name: 'Canada',        areaId: 'NA'  },
  { id: 'MIDWEST',       name: 'Midwest',       areaId: 'NA'  },
  { id: 'NORTHEAST',     name: 'Northeast',     areaId: 'NA'  },
  { id: 'SOUTH',         name: 'South',         areaId: 'NA'  },
  { id: 'WEST',          name: 'West',          areaId: 'NA'  },
];

const getGlobalRegions = () => {
  return globalRegions;
};



interface WsNotificationSetting {
  globalAreaId?:    string;
  globalRegionId?:  string;
  globalCountryId?: string;
  solutionAreaId:   string;
  recipient: {
    name:  string;
    email: string;
  };
  notifications: {
    solutionSubmitted?: boolean;
    architectAssigned?: boolean;
    dailySummary?:      boolean;
    weeklySymmary?:     boolean;
  };
}



const defaultNotificationSettings: WsNotificationSetting[] = [
  {
    // globalAreaId:    '',
    // globalRegionId:  '',
    // globalCountryId: '',
    solutionAreaId: '01H548HM2HA89VQTVKVCDJ2C3R',
    recipient: {
      name:  'Maris',
      email: 'm.balodis@avanade.com'
    },
    notifications: {
    }
  }
];







export const getGlobalRegionNameFromSolution = (salesProcess: any) => {
  if (salesProcess?.country?.fields?.avanade?.regionId) {
    return getGlobalRegionName(salesProcess.country.fields.avanade.regionId);
  } else {
    return getGlobalRegionName(salesProcess?.fields?.regionId);
  }
};




export const getGlobalRegionName = (globalRegionId: string | undefined) => {
  let globalRegionName = '-';

  const globalRegion = getGlobalRegions().find((gr) => gr.id === globalRegionId);

  if (globalRegion) {

    const globalArea = getGlobalAreas().find((ga) => ga.id === globalRegion.areaId);

    if (globalArea) {
      globalRegionName = `${globalArea.name}-${globalRegion.name}`;
    }
  }

  return globalRegionName;
};










export type {
  WsNotificationSetting
};



export {
  getGlobalAreas,
  getGlobalRegions
};
